import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BadgeCheck } from 'lucide-react';
import { apiCall, useAuth } from '@/App';

// Dipadankan ikut nama sebab ID servis berbeza antara preview dan production
const PICKS = [
  { key: 'trial', cat: /Real MY Promo Combo/, match: /trial.*20 like/i, label: 'Trial 20 Like + Komen', sub: 'FB, IG, TikTok, YouTube' },
  { key: 'promo', cat: /Real MY Promo Combo/, match: /^40\+ promo like \+ komen tiktok/i, label: '40+ Like + Komen TikTok', sub: 'Promo paling laris' },
  { key: 'combo', cat: /Real MY TikTok/, match: /^tiktok engagement combo(?!.*x10)/i, label: 'TikTok Engagement Combo', sub: 'Like, komen, save dan share' },
];

async function loadPicks() {
  const cats = (await apiCall('get', '/categories')).categories || [];
  const wanted = cats.filter(c => PICKS.some(p => p.cat.test(c.name)));
  const lists = await Promise.all(wanted.map(c => apiCall('get', `/services?category_id=${c.id}`).then(d => d.services || []).catch(() => [])));
  const all = lists.flat().filter(s => s.status === 'working');
  const items = PICKS.map(p => {
    const s = all.find(x => p.match.test(x.name));
    return s && { ...p, price: s.price_per_1000, to: `/kedai-real-my?beli=${s.id}` };
  }).filter(Boolean);
  const pkgs = (await apiCall('get', '/packages').catch(() => ({}))).packages || [];
  const live = pkgs.find(x => /live hype starter/i.test(x.name));
  if (live) items.push({ key: 'live', label: 'LIVE HYPE Starter', sub: 'Komen live, tap screen, beg kuning', price: live.price, to: `/kedai-real-my?combo=${live.id}` });
  return items;
}

export function RealMyPackageBox() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => { loadPicks().then(setItems).catch(() => {}); }, []);

  return (
    <aside className="not-prose my-8 rounded-2xl border border-[#E9D5FF] bg-gradient-to-br from-[#F8F5FF] to-white p-5" data-testid="blog-realmy-box">
      <div className="flex items-center gap-2 mb-1">
        <BadgeCheck className="h-5 w-5 text-[#9333EA]" />
        <p className="text-base font-bold text-[#0F172A]">Pakej Real Malaysian Engagement</p>
      </div>
      <p className="text-xs text-[#6B7280] mb-4">Interaksi dari pengguna Malaysia sebenar. Tanpa password, penghantaran berperingkat.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {items.map(it => (
          <Link key={it.key} to={user ? it.to : '/signup'} data-testid={`blog-realmy-pkg-${it.key}`}
            className="group flex items-center justify-between gap-3 rounded-xl border border-[#E9D5FF] bg-white p-3.5 transition-colors hover:border-[#9333EA]">
            <div className="min-w-0">
              <p className="text-sm font-semibold text-[#0F172A] leading-snug">{it.label}</p>
              <p className="text-[11px] text-[#9CA3AF]">{it.sub}</p>
              <p className="mt-1 text-lg font-extrabold text-[#9333EA] tabular-nums" data-testid={`blog-realmy-price-${it.key}`}>RM{Number(it.price).toFixed(2)}</p>
            </div>
            <span className="shrink-0 h-8 px-3 rounded-full bg-[#9333EA] text-white text-xs font-bold flex items-center gap-1 transition-transform group-hover:translate-x-0.5">
              {user ? 'Order' : 'Daftar & Order'} <ArrowRight className="h-3 w-3" />
            </span>
          </Link>
        ))}
      </div>
      <Link to="/real-malaysian-engagement" data-testid="blog-realmy-see-all" className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-[#9333EA] hover:underline">
        Lihat semua 150+ pakej Real MY <ArrowRight className="h-3 w-3" />
      </Link>
    </aside>
  );
}
